var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.Layout,[_c('BaseContent',{staticClass:"page",attrs:{"title":"Mixes"}},[_c('BaseTabPanel',{staticClass:"tabs",attrs:{"tabs":_setup.tabs,"is-underlined":"","is-unpadded":"","address-navigation":""}}),_c(_setup.mainView,{tag:"component",staticClass:"component"})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }